type Props = {
  label: string
  title: string
  body: string
  cta: string
  onDismiss: () => void
}

export function CoachMark({ label, title, body, cta, onDismiss }: Props) {
  return (
    <div className="rounded-xl border border-amber-700/50 bg-stone-800/95 p-3 shadow-lg">
      <div className="text-[10px] uppercase tracking-[0.2em] text-amber-400">{label}</div>
      <h3 className="mt-1 text-sm font-semibold text-stone-100">{title}</h3>
      <p className="mt-1 text-xs text-stone-300">{body}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="mt-3 w-full rounded-md border border-amber-700/70 bg-amber-900/30 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-amber-200 hover:bg-amber-900/60"
      >
        {cta}
      </button>
    </div>
  )
}
